import { Box } from '@rbilabs/universal-components';
import { withTypography } from 'ucl/components/text/Typography';

export const ContentContainer = Box.withConfig({
  paddingBottom: '8',
});

export const PrimaryText = withTypography({
  textAlign: 'center',
  style: { marginVertical: 8, marginHorizontal: 'auto' },
});

export const SecondaryText = withTypography({ textAlign: 'center' });
